var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fee-list-page" },
    [
      _c("div", { staticClass: "statistics-container" }, [
        _c("div", { staticClass: "statistic-card card-primary" }, [
          _c(
            "div",
            { staticClass: "statistic-value statistic-value--amount" },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.displayCardValue(_vm.cardData.payableAmount))
                ),
              ]),
              _vm.cardData.standardCurrency
                ? _c("span", { staticClass: "statistic-currency" }, [
                    _vm._v(_vm._s(_vm.cardData.standardCurrency)),
                  ])
                : _vm._e(),
            ]
          ),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("feeTab.payableTotal"))),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-warning" }, [
          _c("div", { staticClass: "statistic-value" }, [
            _vm._v(
              _vm._s(_vm.displayCardValue(_vm.cardData.pendingPayableAmount))
            ),
          ]),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("feeTab.payablePending"))),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-success" }, [
          _c("div", { staticClass: "statistic-value" }, [
            _vm._v(
              _vm._s(_vm.displayCardValue(_vm.cardData.payableFeeItemCount))
            ),
          ]),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("feeTab.feeItems"))),
          ]),
        ]),
      ]),
      _c(
        "el-tabs",
        {
          staticClass: "fee-data-tabs",
          attrs: { type: "card" },
          model: {
            value: _vm.activeFeeTab,
            callback: function ($$v) {
              _vm.activeFeeTab = $$v
            },
            expression: "activeFeeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("feeTab.summary"),
                name: "summary",
                lazy: "",
              },
            },
            [
              _c("FeeCostTable", {
                attrs: {
                  mode: "summary",
                  type: 1,
                  "file-name": _vm.$t("feeTab.payableSummaryFileName"),
                  "fee-item-list": _vm.feeItemList,
                  "charge-unit-list": _vm.chargeUnitList,
                  "outer-order-no": _vm.outerOrderNo,
                },
                on: { "refresh-card": _vm.getOrderQuateCard },
              }),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("feeTab.detail"),
                name: "detail",
                lazy: "",
              },
            },
            [
              _c("FeeCostTable", {
                attrs: {
                  mode: "detail",
                  type: 1,
                  "file-name": _vm.$t("feeTab.payableDetailFileName"),
                  "fee-item-list": _vm.feeItemList,
                  "charge-unit-list": _vm.chargeUnitList,
                  "outer-order-no": _vm.outerOrderNo,
                },
                on: { "refresh-card": _vm.getOrderQuateCard },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }